export const privacyContent = {
  en: {
    title: 'PRIVACY POLICY',
    lastUpdatedLabel: 'Last Updated',
    lastUpdatedValue: 'April 15, 2026',
    intro:
      'Cohen Tucker & Ades, P.C. ("Firm," "we," "our," or "us") respects your privacy.',
    sections: [
      {
        heading: '1. INFORMATION WE COLLECT',
        items: [
          'Contact information, including name, email address, and phone number',
          'Information you submit through forms in the app',
          'Device and usage information, such as browser type and interaction data',
        ],
      },
      {
        heading: '2. HOW WE USE INFORMATION',
        items: [
          'Respond to inquiries',
          'Evaluate potential legal matters',
          'Communicate with users',
          'Improve application functionality and services',
          'Send follow-up and marketing communications',
        ],
      },
      {
        heading: '3. COMMUNICATIONS & SMS CONSENT',
        paragraphs: [
          'By providing your contact information, you consent to receive communications including phone calls, emails, and SMS messages.',
          'Message and data rates may apply.',
          'You may opt out at any time.',
        ],
      },
      {
        heading: '4. DATA SHARING',
        paragraphs: [
          'We do NOT sell personal information.',
          'We may share data with:',
          'We may use aggregated or anonymized data for analytics and internal purposes.',
        ],
        items: [
          'Service providers, such as hosting, analytics, and messaging tools',
          'Legal authorities when required by law',
        ],
      },
      {
        heading: '5. DATA SECURITY',
        paragraphs: [
          'We implement reasonable safeguards to protect data. No system is completely secure.',
        ],
      },
      {
        heading: '6. DATA RETENTION',
        paragraphs: [
          'We retain information as necessary for business, operational, and legal purposes.',
        ],
      },
      {
        heading: '7. USER RIGHTS',
        paragraphs: ['Users may request:'],
        items: [
          'Access to their data',
          'Correction of inaccurate data',
          'Deletion of data',
        ],
      },
      {
        heading: '8. CHILDREN',
        paragraphs: ['This app is not intended for users under 18.'],
      },
      {
        heading: '9. APP STORE PRIVACY DISCLOSURES',
        paragraphs: ['For purposes of platform compliance:'],
        items: [
          'We collect contact information provided directly by users',
          'We do NOT sell personal data',
          'We do NOT use third-party advertising tracking',
          'Data is used for client communication, intake, and service improvement',
        ],
      },
      {
        heading: '10. TRACKING & MARKETING',
        paragraphs: [
          'We do not use cross-app tracking or third-party advertising tracking technologies.',
          'Any marketing communications are based solely on user-provided information.',
        ],
      },
      {
        heading: '11. CHANGES',
        paragraphs: ['We may update this policy at any time.'],
      },
      {
        heading: '12. CONTACT',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  es: {
    title: 'POLITICA DE PRIVACIDAD',
    lastUpdatedLabel: 'Ultima actualizacion',
    lastUpdatedValue: '15 de abril de 2026',
    intro:
      'Cohen Tucker & Ades, P.C. ("la Firma", "nosotros", "nuestro" o "nos") respeta su privacidad.',
    sections: [
      {
        heading: '1. INFORMACION QUE RECOPILAMOS',
        items: [
          'Informacion de contacto, incluido nombre, correo electronico y numero de telefono',
          'Informacion que usted envia mediante formularios en la aplicacion',
          'Informacion del dispositivo y del uso, como el tipo de navegador y los datos de interaccion',
        ],
      },
      {
        heading: '2. COMO USAMOS LA INFORMACION',
        items: [
          'Responder a consultas',
          'Evaluar posibles asuntos legales',
          'Comunicarnos con los usuarios',
          'Mejorar la funcionalidad y los servicios de la aplicacion',
          'Enviar comunicaciones de seguimiento y mercadeo',
        ],
      },
      {
        heading: '3. COMUNICACIONES Y CONSENTIMIENTO PARA SMS',
        paragraphs: [
          'Al proporcionar su informacion de contacto, usted acepta recibir comunicaciones, incluidas llamadas telefonicas, correos electronicos y mensajes SMS.',
          'Pueden aplicarse cargos por mensajes y datos.',
          'Puede optar por no participar en cualquier momento.',
        ],
      },
      {
        heading: '4. COMPARTIR DATOS',
        paragraphs: [
          'NO vendemos informacion personal.',
          'Podemos compartir datos con:',
          'Podemos usar datos agregados o anonimizados para analisis y fines internos.',
        ],
        items: [
          'Proveedores de servicios, como alojamiento, analisis y herramientas de mensajeria',
          'Autoridades legales cuando la ley lo requiera',
        ],
      },
      {
        heading: '5. SEGURIDAD DE LOS DATOS',
        paragraphs: [
          'Aplicamos medidas razonables para proteger los datos. Ningun sistema es completamente seguro.',
        ],
      },
      {
        heading: '6. CONSERVACION DE DATOS',
        paragraphs: [
          'Conservamos la informacion segun sea necesario para fines comerciales, operativos y legales.',
        ],
      },
      {
        heading: '7. DERECHOS DEL USUARIO',
        paragraphs: ['Los usuarios pueden solicitar:'],
        items: [
          'Acceso a sus datos',
          'Correccion de datos inexactos',
          'Eliminacion de datos',
        ],
      },
      {
        heading: '8. MENORES',
        paragraphs: ['Esta aplicacion no esta destinada a usuarios menores de 18 anos.'],
      },
      {
        heading: '9. DIVULGACIONES DE PRIVACIDAD PARA TIENDAS DE APLICACIONES',
        paragraphs: ['Para fines de cumplimiento en plataformas:'],
        items: [
          'Recopilamos informacion de contacto proporcionada directamente por los usuarios',
          'NO vendemos datos personales',
          'NO usamos seguimiento publicitario de terceros',
          'Los datos se usan para comunicacion con clientes, intake y mejora del servicio',
        ],
      },
      {
        heading: '10. SEGUIMIENTO Y MERCADEO',
        paragraphs: [
          'No usamos tecnologias de seguimiento entre aplicaciones ni seguimiento publicitario de terceros.',
          'Cualquier comunicacion de mercadeo se basa unicamente en la informacion proporcionada por el usuario.',
        ],
      },
      {
        heading: '11. CAMBIOS',
        paragraphs: ['Podemos actualizar esta politica en cualquier momento.'],
      },
      {
        heading: '12. CONTACTO',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  ht: {
    title: 'RÈGLEMAN SOU VI PRIVE',
    lastUpdatedLabel: 'Dènye mizajou',
    lastUpdatedValue: '15 avril 2026',
    intro:
      'Cohen Tucker & Ades, P.C. ("Kabinè a", "nou", oswa "pa nou") respekte vi prive ou.',
    sections: [
      {
        heading: '1. ENFOMASYON NOU RANMASE',
        items: [
          'Enfomasyon kontak, tankou non, imel, ak nimewo telefon',
          'Enfomasyon ou voye atravè fòm nan aplikasyon an',
          'Enfomasyon sou aparèy ak fason ou itilize aplikasyon an, tankou kalite navigatè ak done entèraksyon',
        ],
      },
      {
        heading: '2. KIJAN NOU ITILIZE ENFOMASYON AN',
        items: [
          'Reponn kestyon ak demann',
          'Evalye kestyon legal potansyèl',
          'Kominike ak itilizatè yo',
          'Amelyore fonksyon aplikasyon an ak sèvis yo',
          'Voye mesaj swivi ak maketing',
        ],
      },
      {
        heading: '3. KOMINIKASYON AK KONSANTMAN SMS',
        paragraphs: [
          'Lè ou bay enfomasyon kontak ou, ou dakò pou resevwa kominikasyon tankou apèl telefon, imel, ak mesaj SMS.',
          'Frè mesaj ak done ka aplike.',
          'Ou ka sispann resevwa yo nenpòt kilè.',
        ],
      },
      {
        heading: '4. PATAJ DONE',
        paragraphs: [
          'Nou PA vann enfomasyon pèsonèl.',
          'Nou ka pataje done ak:',
          'Nou ka itilize done total oswa done anonim pou analiz ak rezon entèn.',
        ],
        items: [
          'Founisè sèvis tankou hosting, analiz, ak zouti mesaj',
          'Otorite legal lè lalwa mande sa',
        ],
      },
      {
        heading: '5. SEKIRITE DONE',
        paragraphs: [
          'Nou mete pwoteksyon rezonab anplas pou pwoteje done yo. Pa gen okenn sistèm ki konplètman an sekirite.',
        ],
      },
      {
        heading: '6. KONBYEN TAN NOU KENBE DONE YO',
        paragraphs: [
          'Nou kenbe enfomasyon jan sa nesesè pou rezon biznis, operasyon, ak legal.',
        ],
      },
      {
        heading: '7. DWA ITILIZATÈ YO',
        paragraphs: ['Itilizatè yo ka mande:'],
        items: [
          'Aksè ak done yo',
          'Koreksyon done ki pa kòrèk',
          'Efase done yo',
        ],
      },
      {
        heading: '8. TIMOUN',
        paragraphs: ['Aplikasyon sa a pa fèt pou itilizatè ki poko gen 18 an.'],
      },
      {
        heading: '9. DEKLARASYON PRIVE POU APP STORE',
        paragraphs: ['Pou rezon konfòmite sou platfòm yo:'],
        items: [
          'Nou ranmase enfomasyon kontak itilizatè yo bay dirèkteman',
          'Nou PA vann done pèsonèl',
          'Nou PA itilize swivi piblisite twazyèm pati',
          'Done yo sèvi pou kominikasyon kliyan, intake, ak amelyorasyon sèvis',
        ],
      },
      {
        heading: '10. SUIVI AK MAKETING',
        paragraphs: [
          'Nou pa itilize teknoloji swivi atravè aplikasyon ni swivi piblisite twazyèm pati.',
          'Nenpòt kominikasyon maketing baze sèlman sou enfomasyon itilizatè a bay.',
        ],
      },
      {
        heading: '11. CHANJMAN',
        paragraphs: ['Nou ka mete règleman sa a ajou nenpòt kilè.'],
      },
      {
        heading: '12. KONTAK',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  pt: {
    title: 'POLITICA DE PRIVACIDADE',
    lastUpdatedLabel: 'Ultima atualizacao',
    lastUpdatedValue: '15 de abril de 2026',
    intro:
      'Cohen Tucker & Ades, P.C. ("Escritorio", "nos", "nosso" ou "nossa") respeita a sua privacidade.',
    sections: [
      {
        heading: '1. INFORMACOES QUE COLETAMOS',
        items: [
          'Informacoes de contato, incluindo nome, e-mail e numero de telefone',
          'Informacoes enviadas por voce por meio de formularios no aplicativo',
          'Informacoes do dispositivo e de uso, como tipo de navegador e dados de interacao',
        ],
      },
      {
        heading: '2. COMO USAMOS AS INFORMACOES',
        items: [
          'Responder a consultas',
          'Avaliar possiveis assuntos juridicos',
          'Nos comunicar com os usuarios',
          'Melhorar a funcionalidade e os servicos do aplicativo',
          'Enviar comunicacoes de acompanhamento e marketing',
        ],
      },
      {
        heading: '3. COMUNICACOES E CONSENTIMENTO PARA SMS',
        paragraphs: [
          'Ao fornecer suas informacoes de contato, voce concorda em receber comunicacoes, incluindo ligacoes, e-mails e mensagens SMS.',
          'Podem ser aplicadas tarifas de mensagem e dados.',
          'Voce pode optar por sair a qualquer momento.',
        ],
      },
      {
        heading: '4. COMPARTILHAMENTO DE DADOS',
        paragraphs: [
          'NAO vendemos informacoes pessoais.',
          'Podemos compartilhar dados com:',
          'Podemos usar dados agregados ou anonimizados para analises e finalidades internas.',
        ],
        items: [
          'Prestadores de servico, como hospedagem, analise e ferramentas de mensagens',
          'Autoridades legais quando exigido por lei',
        ],
      },
      {
        heading: '5. SEGURANCA DOS DADOS',
        paragraphs: [
          'Implementamos medidas razoaveis para proteger os dados. Nenhum sistema e totalmente seguro.',
        ],
      },
      {
        heading: '6. RETENCAO DE DADOS',
        paragraphs: [
          'Mantemos as informacoes conforme necessario para fins comerciais, operacionais e legais.',
        ],
      },
      {
        heading: '7. DIREITOS DO USUARIO',
        paragraphs: ['Os usuarios podem solicitar:'],
        items: [
          'Acesso aos seus dados',
          'Correcao de dados imprecisos',
          'Exclusao de dados',
        ],
      },
      {
        heading: '8. CRIANCAS',
        paragraphs: ['Este aplicativo nao se destina a usuarios menores de 18 anos.'],
      },
      {
        heading: '9. DIVULGACOES DE PRIVACIDADE PARA LOJAS DE APLICATIVOS',
        paragraphs: ['Para fins de conformidade com as plataformas:'],
        items: [
          'Coletamos informacoes de contato fornecidas diretamente pelos usuarios',
          'NAO vendemos dados pessoais',
          'NAO usamos rastreamento publicitario de terceiros',
          'Os dados sao usados para comunicacao com clientes, intake e melhoria do servico',
        ],
      },
      {
        heading: '10. RASTREAMENTO E MARKETING',
        paragraphs: [
          'Nao usamos tecnologias de rastreamento entre aplicativos nem rastreamento publicitario de terceiros.',
          'Qualquer comunicacao de marketing baseia-se somente nas informacoes fornecidas pelo usuario.',
        ],
      },
      {
        heading: '11. ALTERACOES',
        paragraphs: ['Podemos atualizar esta politica a qualquer momento.'],
      },
      {
        heading: '12. CONTATO',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  zh: {
    title: '隐私政策',
    lastUpdatedLabel: '最后更新',
    lastUpdatedValue: '2026年4月15日',
    intro:
      'Cohen Tucker & Ades, P.C.（以下简称“本所”“我们”）尊重您的隐私。',
    sections: [
      {
        heading: '1. 我们收集的信息',
        items: [
          '联系信息，包括姓名、电子邮件地址和电话号码',
          '您通过应用内表格提交的信息',
          '设备和使用信息，例如浏览器类型和互动数据',
        ],
      },
      {
        heading: '2. 我们如何使用信息',
        items: [
          '回应咨询',
          '评估潜在法律事务',
          '与用户沟通',
          '改进应用功能和服务',
          '发送后续沟通和营销信息',
        ],
      },
      {
        heading: '3. 通讯与短信同意',
        paragraphs: [
          '当您提供联系信息时，即表示您同意接收通讯，包括电话、电子邮件和短信。',
          '短信和数据费用可能适用。',
          '您可以随时选择退出。',
        ],
      },
      {
        heading: '4. 数据共享',
        paragraphs: [
          '我们不会出售个人信息。',
          '我们可能与以下对象共享数据：',
          '我们也可能将汇总或匿名化的数据用于分析和内部用途。',
        ],
        items: [
          '服务提供商，例如托管、分析和消息工具',
          '法律要求时的相关政府或执法机构',
        ],
      },
      {
        heading: '5. 数据安全',
        paragraphs: ['我们采取合理的保护措施来保障数据安全，但没有任何系统是绝对安全的。'],
      },
      {
        heading: '6. 数据保留',
        paragraphs: ['我们会在业务、运营和法律需要的范围内保留相关信息。'],
      },
      {
        heading: '7. 用户权利',
        paragraphs: ['用户可以请求：'],
        items: [
          '访问其数据',
          '更正不准确的数据',
          '删除数据',
        ],
      },
      {
        heading: '8. 儿童',
        paragraphs: ['本应用不面向18岁以下用户。'],
      },
      {
        heading: '9. 应用商店隐私披露',
        paragraphs: ['为满足平台合规要求：'],
        items: [
          '我们收集用户直接提供的联系信息',
          '我们不会出售个人数据',
          '我们不会使用第三方广告跟踪',
          '数据用于客户沟通、登记和服务改进',
        ],
      },
      {
        heading: '10. 跟踪与营销',
        paragraphs: [
          '我们不使用跨应用跟踪或第三方广告跟踪技术。',
          '任何营销沟通都仅基于用户主动提供的信息。',
        ],
      },
      {
        heading: '11. 变更',
        paragraphs: ['我们可能会随时更新本政策。'],
      },
      {
        heading: '12. 联系方式',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
};

export const termsContent = {
  en: {
    title: 'TERMS OF SERVICE',
    lastUpdatedLabel: 'Last Updated',
    lastUpdatedValue: 'April 5, 2026',
    intro: 'This application is operated by Cohen Tucker & Ades, P.C. ("Firm").',
    sections: [
      {
        heading: '1. NO LEGAL ADVICE',
        paragraphs: ['This app provides general information only and does not constitute legal advice.'],
      },
      {
        heading: '2. NO ATTORNEY-CLIENT RELATIONSHIP',
        paragraphs: [
          'Use of this app or submission of information does not create an attorney-client relationship.',
        ],
      },
      {
        heading: '3. ATTORNEY ADVERTISING',
        paragraphs: ['This app may be considered Attorney Advertising. Prior results do not guarantee similar outcomes.'],
      },
      {
        heading: '4. USER RESPONSIBILITIES',
        paragraphs: ['You agree to provide accurate information and not misuse the app.'],
      },
      {
        heading: '5. COMMUNICATION CONSENT (TCPA)',
        paragraphs: [
          'By submitting your information, you expressly consent to be contacted by Cohen Tucker & Ades, P.C. via:',
          'These communications may include appointment scheduling, follow-ups, and marketing.',
          'Message and data rates may apply.',
          'Consent is not a condition of purchase or hiring legal services.',
          'You may opt out at any time by replying STOP to SMS messages.',
        ],
        items: ['Phone calls', 'Emails', 'SMS/text messages'],
      },
      {
        heading: '6. DATA USAGE',
        paragraphs: ['Information submitted may be stored and used for:'],
        items: [
          'Client intake',
          'Case evaluation',
          'Internal business operations',
          'Marketing and follow-up communications',
        ],
      },
      {
        heading: '7. LIMITATION OF LIABILITY',
        paragraphs: ['The Firm is not responsible for reliance on app content or technical issues.'],
      },
      {
        heading: '8. GOVERNING LAW',
        paragraphs: ['New York law applies.'],
      },
      {
        heading: '9. CONTACT',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  es: {
    title: 'TERMINOS DE SERVICIO',
    lastUpdatedLabel: 'Ultima actualizacion',
    lastUpdatedValue: '5 de abril de 2026',
    intro: 'Esta aplicacion es operada por Cohen Tucker & Ades, P.C. ("la Firma").',
    sections: [
      {
        heading: '1. NO ES ASESORIA LEGAL',
        paragraphs: ['Esta aplicacion solo proporciona informacion general y no constituye asesoria legal.'],
      },
      {
        heading: '2. NO EXISTE RELACION ABOGADO-CLIENTE',
        paragraphs: [
          'El uso de esta aplicacion o el envio de informacion no crea una relacion abogado-cliente.',
        ],
      },
      {
        heading: '3. PUBLICIDAD DE ABOGADOS',
        paragraphs: ['Esta aplicacion puede considerarse publicidad de abogados. Los resultados previos no garantizan resultados similares.'],
      },
      {
        heading: '4. RESPONSABILIDADES DEL USUARIO',
        paragraphs: ['Usted acepta proporcionar informacion precisa y no hacer un uso indebido de la aplicacion.'],
      },
      {
        heading: '5. CONSENTIMIENTO PARA COMUNICACIONES (TCPA)',
        paragraphs: [
          'Al enviar su informacion, usted autoriza expresamente a Cohen Tucker & Ades, P.C. a comunicarse con usted por medio de:',
          'Estas comunicaciones pueden incluir programacion de citas, seguimientos y mercadeo.',
          'Pueden aplicarse cargos por mensajes y datos.',
          'El consentimiento no es una condicion para comprar ni contratar servicios legales.',
          'Puede optar por no participar en cualquier momento respondiendo STOP a los mensajes SMS.',
        ],
        items: ['Llamadas telefonicas', 'Correos electronicos', 'Mensajes SMS o de texto'],
      },
      {
        heading: '6. USO DE LOS DATOS',
        paragraphs: ['La informacion enviada puede almacenarse y usarse para:'],
        items: [
          'Intake de clientes',
          'Evaluacion de casos',
          'Operaciones internas del negocio',
          'Comunicaciones de mercadeo y seguimiento',
        ],
      },
      {
        heading: '7. LIMITACION DE RESPONSABILIDAD',
        paragraphs: ['La Firma no es responsable por confiar en el contenido de la aplicacion ni por problemas tecnicos.'],
      },
      {
        heading: '8. LEY APLICABLE',
        paragraphs: ['Se aplica la ley del estado de Nueva York.'],
      },
      {
        heading: '9. CONTACTO',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  ht: {
    title: 'KONDISYON SÈVIS',
    lastUpdatedLabel: 'Dènye mizajou',
    lastUpdatedValue: '5 avril 2026',
    intro: 'Cohen Tucker & Ades, P.C. ("Kabinè a") opere aplikasyon sa a.',
    sections: [
      {
        heading: '1. PA GEN KONSÈY LEGAL',
        paragraphs: ['Aplikasyon sa a bay enfomasyon jeneral sèlman epi li pa bay konsèy legal.'],
      },
      {
        heading: '2. PA GEN RELASYON AVOKA-AK-KLIYAN',
        paragraphs: [
          'Itilizasyon aplikasyon sa a oswa voye enfomasyon pa kreye yon relasyon avoka-ak-kliyan.',
        ],
      },
      {
        heading: '3. PIBLISITE AVOKA',
        paragraphs: ['Aplikasyon sa a ka konsidere kòm piblisite avoka. Rezilta anvan yo pa garanti menm kalite rezilta yo.'],
      },
      {
        heading: '4. RESPONSABLITE ITILIZATÈ A',
        paragraphs: ['Ou dakò pou bay enfomasyon ki kòrèk epi pou pa fè move itilizasyon aplikasyon an.'],
      },
      {
        heading: '5. KONSANTMAN POU KOMINIKASYON (TCPA)',
        paragraphs: [
          'Lè ou soumèt enfomasyon ou, ou bay Cohen Tucker & Ades, P.C. pèmisyon klè pou kontakte ou atravè:',
          'Kominikasyon sa yo ka gen ladan randevou, swivi, ak maketing.',
          'Frè mesaj ak done ka aplike.',
          'Konsantman pa yon kondisyon pou achte oswa anboche sèvis legal.',
          'Ou ka sispann resevwa mesaj nenpòt kilè lè ou reponn STOP nan SMS yo.',
        ],
        items: ['Apèl telefon', 'Imel', 'SMS oswa mesaj tèks'],
      },
      {
        heading: '6. ITILIZASYON DONE',
        paragraphs: ['Enfomasyon ou soumèt la ka estoke epi itilize pou:'],
        items: [
          'Intake kliyan',
          'Evalyasyon dosye',
          'Operasyon entèn biznis la',
          'Maketing ak kominikasyon swivi',
        ],
      },
      {
        heading: '7. LIMIT RESPONSABLITE',
        paragraphs: ['Kabinè a pa responsab si yon moun konte sou kontni aplikasyon an oswa si gen pwoblèm teknik.'],
      },
      {
        heading: '8. LWA KI APLIKE',
        paragraphs: ['Lwa Eta New York aplike.'],
      },
      {
        heading: '9. KONTAK',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  pt: {
    title: 'TERMOS DE SERVICO',
    lastUpdatedLabel: 'Ultima atualizacao',
    lastUpdatedValue: '5 de abril de 2026',
    intro: 'Este aplicativo e operado por Cohen Tucker & Ades, P.C. ("Escritorio").',
    sections: [
      {
        heading: '1. NAO E ORIENTACAO JURIDICA',
        paragraphs: ['Este aplicativo fornece apenas informacoes gerais e nao constitui orientacao juridica.'],
      },
      {
        heading: '2. NAO HA RELACAO ADVOGADO-CLIENTE',
        paragraphs: [
          'O uso deste aplicativo ou o envio de informacoes nao cria uma relacao advogado-cliente.',
        ],
      },
      {
        heading: '3. PUBLICIDADE DE ADVOCACIA',
        paragraphs: ['Este aplicativo pode ser considerado publicidade de advocacia. Resultados anteriores nao garantem resultados semelhantes.'],
      },
      {
        heading: '4. RESPONSABILIDADES DO USUARIO',
        paragraphs: ['Voce concorda em fornecer informacoes precisas e em nao fazer uso indevido do aplicativo.'],
      },
      {
        heading: '5. CONSENTIMENTO PARA COMUNICACOES (TCPA)',
        paragraphs: [
          'Ao enviar suas informacoes, voce autoriza expressamente Cohen Tucker & Ades, P.C. a entrar em contato por meio de:',
          'Essas comunicacoes podem incluir agendamento de consultas, acompanhamentos e marketing.',
          'Podem ser aplicadas tarifas de mensagem e dados.',
          'O consentimento nao e condicao para compra ou contratacao de servicos juridicos.',
          'Voce pode cancelar a qualquer momento respondendo STOP as mensagens SMS.',
        ],
        items: ['Ligacoes telefonicas', 'E-mails', 'SMS ou mensagens de texto'],
      },
      {
        heading: '6. USO DOS DADOS',
        paragraphs: ['As informacoes enviadas podem ser armazenadas e usadas para:'],
        items: [
          'Intake de clientes',
          'Avaliacao de casos',
          'Operacoes internas do negocio',
          'Marketing e comunicacoes de acompanhamento',
        ],
      },
      {
        heading: '7. LIMITACAO DE RESPONSABILIDADE',
        paragraphs: ['O Escritorio nao e responsavel por confianca no conteudo do aplicativo nem por problemas tecnicos.'],
      },
      {
        heading: '8. LEI APLICAVEL',
        paragraphs: ['Aplica-se a lei do Estado de Nova York.'],
      },
      {
        heading: '9. CONTATO',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
  zh: {
    title: '服务条款',
    lastUpdatedLabel: '最后更新',
    lastUpdatedValue: '2026年4月5日',
    intro: '本应用由 Cohen Tucker & Ades, P.C.（以下简称“本所”）运营。',
    sections: [
      {
        heading: '1. 不构成法律意见',
        paragraphs: ['本应用仅提供一般信息，不构成法律意见。'],
      },
      {
        heading: '2. 不建立律师与客户关系',
        paragraphs: ['使用本应用或提交信息并不会建立律师与客户关系。'],
      },
      {
        heading: '3. 律师广告',
        paragraphs: ['本应用可能被视为律师广告。过往结果并不保证未来取得类似结果。'],
      },
      {
        heading: '4. 用户责任',
        paragraphs: ['您同意提供准确的信息，并不得滥用本应用。'],
      },
      {
        heading: '5. 通讯同意（TCPA）',
        paragraphs: [
          '提交您的信息即表示您明确同意 Cohen Tucker & Ades, P.C. 通过以下方式与您联系：',
          '这些沟通可能包括预约安排、后续联系和营销信息。',
          '短信和数据费用可能适用。',
          '同意并不是购买或聘请法律服务的前提条件。',
          '您可以随时通过回复短信“STOP”取消接收。',
        ],
        items: ['电话', '电子邮件', '短信/文本消息'],
      },
      {
        heading: '6. 数据使用',
        paragraphs: ['提交的信息可能会被存储并用于：'],
        items: [
          '客户登记',
          '案件评估',
          '内部业务运营',
          '营销和后续沟通',
        ],
      },
      {
        heading: '7. 责任限制',
        paragraphs: ['本所不对用户依赖应用内容或技术问题承担责任。'],
      },
      {
        heading: '8. 适用法律',
        paragraphs: ['适用纽约州法律。'],
      },
      {
        heading: '9. 联系方式',
        paragraphs: ['Cohen Tucker & Ades, P.C.'],
      },
    ],
  },
};
